import { Injectable } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil, throttleTime } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class ActivityService {
	public readonly userActive$ = new BehaviorSubject<boolean>(false);
	private destroy$!: Subject<void>;

	constructor(private idleService: Idle) {}

	/**
	 * Initializes the idle service to monitor user activity
	 * and sets up an observable to emit user activity events.
	 */
	public startMonitoring(throttleDuration = 3_600_000): void {
		this.destroy$ = new Subject<void>();
		// Configure which user actions (e.g., mouse, keyboard) will reset the idle timer
		this.idleService.setInterrupts(DEFAULT_INTERRUPTSOURCES);

		// Listen for user activity events, but only handle one event per hour
		this.idleService.onInterrupt.pipe(takeUntil(this.destroy$), throttleTime(throttleDuration)).subscribe(() => {
			this.userActive$.next(true); // Notify that user is active
		});

		// Start monitoring for user activity and idleness
		this.idleService.watch();
	}

	// Stop monitoring user activity and reset the idle service
	public stopMonitoring(): void {
		// Stop the idle service and reset any state
		this.idleService.stop();
		if (this.destroy$) {
			this.destroy$.next();
			this.destroy$.complete();
		}
	}
}
